import React from "react";
import { Route } from "react-router-dom";
import { WocommercePriceDeleteDialog } from "./price-dialog/WocommercePriceDeleteDialog";
import WocommercePriceCard from "./WocommercePrice";
import { WocommercePriceUIProvider } from "./WocommercePriceUIContext";

export function WocommercePricePage({ history }) {
  
  const priceUIEvents = {
    newPriceButtonClick: () => {
      history.push(`/app/wocommerceprice/new`);
    },
    openEditPricePage: (id) => {
      history.push(`/app/wocommerceprice/${id}/edit`);
    },
    openDeletePriceDialog: (id) => {
      history.push(`/wocommerce-price/${id}/delete`);
    },
  };

  return (
    <WocommercePriceUIProvider priceUIEvents={priceUIEvents}>
      <Route exact path={`/wocommerce-price/:id/delete`}>
        {({ history, match }) => {
          return (
            <WocommercePriceDeleteDialog
              show={match != null}
              id={match && match.params.id}
              onHide={() => {
                history.push(`/wocommerce-price`);
              }}
            />
          );
        }}
      </Route>
      <WocommercePriceCard />
    </WocommercePriceUIProvider>
  );
}
